export default class Utils {
  static removeFile(filename, filetype) {
    const el = filetype === 'js' ? 'script' : filetype === 'css' ? 'link' : 'none';
    const att = filetype === 'js' ? 'src' : filetype === 'css' ? 'href' : 'none';
    let els = document.getElementsByTagName(el);
    for (let i = els.length; i >= 0; i--) {
      if (
        els[i] &&
        els[i].getAttribute(att) != null &&
        els[i].getAttribute(att).indexOf(filename) !== -1
      )
        els[i].parentNode.removeChild(els[i]);
    }
  }

  static getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  };

  static checkResize(mutations) {
      const el = mutations[0].target;
      const w = el.clientWidth;
      const h = el.clientHeight;

      const isChange = mutations
          .map((m) => `${m.oldValue}`)
          .some((prev) => prev.indexOf(`width: ${w}px`) === -1 || prev.indexOf(`height: ${h}px`) === -1);

      if (!isChange) { return; }
      const event = new CustomEvent('resize', { detail: { width: w, height: h } });
      el.dispatchEvent(event);
  }

  static addResizeObserver = element => {
    const observer = new MutationObserver(Utils.checkResize);
    observer.observe(element, { attributes: true, attributeOldValue: true, attributeFilter: ['style'] });
  }

  static formatNewApiConfigParameter(isNewApi, storage, value) {
    if (!isNewApi) {
      return value;
    }
    return {
      default: value,
      storage,
    };
  }
}
